const appWriteConfig = {
  endpoint: "https://cloud.appwrite.io/v1",
  project_id: "67124fbc000336edcc41",
  str_id: "6715c319001613301065",
};

export default appWriteConfig;
